import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function GetNewStudentRequest(): Promise<ApiResponse> {
  return Axios.get(`v1/candidates/schedule_requests`, {
    params: { filters: { status: "pending" } },
  });
}
